module.exports = __webpack_public_path__ + "img/02-@1x.1ae82625.png";